function switchSwatchDisplay(el) {
    var productTile = el.closest('.product-tile');
    if (productTile) {
        var swatchDisplay = productTile.querySelector(".swatch-display-value");
        if (swatchDisplay) {
            // set swatch display value to color of clicked radio button
            swatchDisplay.textContent = el.value;
        }

        // switch the product tile link
        var productLink = productTile.querySelector(".product-tile-image-link");
        productLink.href = el.dataset.variantUrl;

        // switch the image if the selected swatch has one
        if (el.dataset.imageUrl) {
            switchSwatchImage(el, productTile);
        }

        productTile.dispatchEvent(new CustomEvent('collection-tile:variant-changed', {
            bubbles: true,
            detail: {
                swatchElement: el,
                swatchValue: el.value,
                variantUrl: el.dataset.variantUrl
            }
        }));
    }
}

function switchSwatchImage(el, productTile) {
    
    // get new image urls from radio button data attributes
    var newImageUrl = el.dataset.imageUrl;
    var newSecondaryImageUrl = el.dataset.secondaryImageUrl;

    // find the picture elements within the product tile
    var imgElements = productTile.querySelectorAll("img");

    // iterate over each picture element
    imgElements.forEach(function(imgElement) {

        if (imgElement && newImageUrl && newSecondaryImageUrl) {
            if (imgElement.classList.contains("product-tile-image")) {
                imgElement.src = newImageUrl;
            } else {
                imgElement.src = newSecondaryImageUrl;
            }
        }
    });
}

document.addEventListener('click', function(event) {
    if (event.target.matches('.ColorSwatch__Radio')) {
        switchSwatchDisplay(event.target);
    }
});

function moreSwatchesClicked(el) {
    var productTile = el.closest('.product-tile');
    if (productTile) {
        const link = productTile.querySelector('.product-tile-image-link');
        if (link) {
            link.click();
        }
    }
}

document.addEventListener('click', function(event) {
    if (event.target.matches('.swatch-more')) {
        moreSwatchesClicked(event.target);
    }
});
